<template>
    <div class="cartcontroll notranslate">
        <transition name="slide-fade" v-show="food.groupId==null">
            <mu-button icon color="primary" :class="packageType==0?'decrease':'decrease-buffet'" v-show="food.quantity" @click="decreaseCart">
                <mu-icon value="remove_circle"></mu-icon>
            </mu-button>
        </transition>
        <div :class="packageType==0?'count':'count-buffet'" v-show="food.quantity">{{food.quantity}}</div>

        <mu-button icon color="primary" :class="(addType===true||food.unAdd)?'form-onlyread':'add'" @click="addCart" v-show="food.groupId==null">
            <mu-icon value="add_circle"></mu-icon>
        </mu-button>

        <mu-badge :content="food.unPayTip" v-if="food.unPayTip" style="position:absolute;width:180px;left:-150px;top:20px;z-index: 10000;"></mu-badge>

        <mu-badge :content="getWith()" color="#da5b3a" badge-class="badge-class" @click="openTasteSheet(food.groupId)" v-if="(addType===false && !food.unAdd)" v-show="food.groupId!=null"></mu-badge>

        <mu-bottom-sheet :open.sync="open" style="overflow-y: auto; height: 80%;">
            <mu-list @item-click="closeTasteSheet">
                <mu-sub-header style="padding-left: 10px;font-size: 20px;font-weight: 600;line-height: 24px;padding-top: 5px;">{{food.foodName}}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon notranslate" @click="closeTasteSheet"></mu-icon>
                <div style="margin-bottom: 20px;" v-for="(parentItem,index) in  foodAttribute" :key="index">
                   <div style="font-size: 14px;color: #909399;line-height: 20px;text-align: left;padding-left: 10px;padding-top: 10px;">{{parentItem.attributeName}}</div>
                    <div v-for="item in parentItem.children" @click="selectTastes(item)" :key="item.id" :class="item.isChoice?'stateChoose':'stateNotChoose'" >
                        {{item.attributeName}}&nbsp;&nbsp;
                        <span>|</span>
                        &nbsp;&nbsp;
                        <span style="color: #f01414;font-size: 13px;font-weight:bold;">{{ (food.price+item.attributePrice) }} {{seller.unit}}</span>
                    </div>
                </div>
                <div style="padding-left: 20px;padding-right: 20px;margin-bottom: 20px;line-height: 40px;background-color:#F2F6FC;">
                     {{$t('orderList.choice')}} : {{food.decideName}}
                </div>
                <div style="padding-left: 20px;">
                    <div style="text-align: right;padding-right: 20px;">
                    <span style="font-weight:bold;font-size: 14px;">
                        {{$t('orderList.total')}}
                    </span>&nbsp;
                    <span style="color: #f01414;font-size: 20px;font-weight: 600;">
                        {{food.payAmount}}
                    </span>
                    <span style="color: #f01414;font-size: 14px;">
                        {{seller.unit}}
                    </span>
                </div>
                    <!-- <div style="text-align: right;margin-right: 20px;margin-top: -30px; "><mu-button color="success" class="notranslate"  @click="sureTasteSheet" style="text-transform:unset;">{{$t('common.sure')}}</mu-button></div> -->
                </div>
                <div style="padding: 20px;margin-bottom: 20px;">
                    <mu-button color="primary" large full-width @click="sureTasteSheet" style="background-color:#da5b3a;text-transform: unset;">
                        {{$t('common.sure')}}
                    </mu-button>
                </div>
            </mu-list>
        </mu-bottom-sheet>

    </div>   
</template>

<script>
  import Vue from 'vue'
import { eventBus } from '../utils/event-bus'

  export default {
        props: {
            packageType: {
                type: Number,
                default: 0
            },
            food: {
                type: Object
          },
          addType: {
              type: Boolean
          },
        },
        data() {
            return {
                foodAttributeAll: [],
                foodAttribute: [],
                open: false,
                tableOrderInfo:{},
                seller:{}
            }
        },
        created() {
            
        },
        mounted() {
          
        },
    methods: {
        addCart(e) {
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1);
                if(this.food.chargedOnce==1 && this.food.payAmount>0){
                    var tips=this.$t("orderList.chargedOnceTips");
                    if(window.localStorage.getItem('oneTimeCharge')!=undefined && window.localStorage.getItem('oneTimeCharge')!=null && window.localStorage.getItem('oneTimeCharge')!=''){
                        tips=window.localStorage.getItem('oneTimeCharge');
                    }
                    this.$alert(tips, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                }
            } else {
                this.food.quantity += 1;
            }

        // 优化体验，异步传递当前点击文档节点
            this.$nextTick(() => {
                eventBus.$emit('addcart', e.target)
        })
      },
      decreaseCart () {
          if (this.food.quantity) {
              this.food.quantity--
               if(this.food.quantity==0){
                 Vue.set(this.food, 'payAmount', this.food.price)
               }
          }
        },
        getWith() {
            return this.$t('orderList.with');
        },
        selectTastes(it) {
            var decideNameArr=[];
            var extPrice=0;
            this.foodAttribute.forEach((item) => {
                if(item.id==it.parentId){
                    item.children.forEach((item1) => {
                        if(it.id==item1.id){
                            if(!item1.isChoice){
                                item1.isChoice=true;
                                extPrice+=item1.attributePrice;
                                decideNameArr.push(item1.attributeName);
                            }
                            else{
                                item1.isChoice=!item1.isChoice;
                            }
                        }
                        else{
                            if(item.model==1){
                                item1.isChoice=false;
                            }
                            else{
                                if(item1.isChoice){
                                    extPrice+=item1.attributePrice;
                                    decideNameArr.push(item1.attributeName);
                                }
                            }
                        }
                    })
                }
                else{
                    item.children.forEach((item1) => {
                        if(item1.isChoice){
                            extPrice+=item1.attributePrice;
                            decideNameArr.push(item1.attributeName);
                        }
                    })
                }
            })
            this.food.payAmount=parseFloat(Number((this.food.price * this.food.actDiscount)+extPrice).toFixed(0));
           let t=decideNameArr.join(',');
            if (this.food.decideName == null) {
                Vue.set(this.food, 'decideName', t)
            } else {
                this.food.decideName = t;
            }
        },
        sureTasteSheet(){
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1)
            } else {
                this.food.quantity += 1
            }
            this.open = false;
        },
        closeTasteSheet() {
            this.open = false;
        },
        openTasteSheet(groupId) {
            this.foodAttribute = [];
            Vue.set(this.food, 'decideName', null)
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.$get('QRCodeOrder/GetAllFoodCustomAttributeList', {restaurantId:this.tableOrderInfo.restaurantId})
                .then(response => {
                    if (response.code == 200) {
                        this.foodAttributeAll = response.data;;
                        var arr = response.data.filter(item => {
                            return groupId.indexOf(item.id) > -1
                        })
                        console.log(arr);
                        arr.forEach((parentItem) => {
                            parentItem.children = response.data.filter(item => {
                                return item.parentId == parentItem.id;
                            })
                        })
                        if(arr.length>0){
                            this.foodAttribute = arr;
                            if(this.foodAttribute[0].children.length>0){
                                this.selectTastes(this.foodAttribute[0].children[0].isChoice=true);
                            }
                        }
                        this.open = true;
                    }
                });
        },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .cartcontroll {
        font-size: 0;
    }

        .cartcontroll .decrease,
        .cartcontroll .add {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #da5b3a;
            padding: 6px;
        }


        .cartcontroll .decrease-buffet,
        .cartcontroll .add-buffet {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #fff;
            padding: 6px;
        }


        .cartcontroll .count {
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            font-weight:600;
            width: 30px;
            line-height: 30px;
            text-align: center;
            color: #da5b3a;
        }

        .cartcontroll .count-buffet {
            display: inline-block;
            vertical-align: top;
            font-size: 12px;
            width: 20px;
            line-height: 30px;
            text-align: center;
            color: #fff;
        }

    .cartcontroll,
    .slide-fade-enter-active {
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        -webkit-transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        /* .slide-fade-leave-active for below version 2.1.8 */
        -webkit-transform: translateX(24px) rotate(360deg);
        transform: translateX(24px) rotate(360deg);
        opacity: 0;
    }

    .foods-wrapper {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        overflow-y: scroll;
    }

     .foods-wrapper h1 {
        margin: 0px;
    }

     .foods-wrapper .title {
        padding-left: 14px;
        border-left: 2px solid #d9dde1;
        font-size: 12px;
        height: 26px;
        line-height: 26px;
        color: #93999f;
        background-color: #f3f5f7;
    }

     .foods-wrapper .food-item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 5px;
        padding-bottom: 10px;
        margin-right: 10px;
        position: relative;
    }

         .foods-wrapper .food-item:after {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-top: 1px solid rgba(7,17,27,0.1);
            content: '';
        }

         .foods-wrapper .food-item:last-child:after {
            border-top: 0;
        }

         .foods-wrapper .food-item .icon {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 57px;
            flex: 0 0 57px;
            margin-right: 10px;
        }

         .foods-wrapper .food-item .content {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            margin-left: 5px;
        }

             .foods-wrapper .food-item .content .name {
                margin: 2px 0 8px 0;
                height: 12px;
                line-height: 12px;
                font-size: 14px;
                color: #07111b;
            }

             .foods-wrapper .food-item .content .description,
             .foods-wrapper .food-item .content .extra {
                font-size: 10px;
                line-height: 10px;
                color: #93999f;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                height: 10px;
                line-height: 10px;
            }

                 .foods-wrapper .food-item .content .extra .count {
                    margin-right: 12px;
                    line-height: 10px;
                }

                 .foods-wrapper .food-item .content .extra .rating {
                    line-height: 10px;
                }

             .foods-wrapper .food-item .content .price .now {
                font-size: 12px;
                color: #f01414;
                font-weight: 700;
                line-height: 24px;
                padding:5px;
            }

             .foods-wrapper .food-item .content .price .old {
                font-size: 12px;
                text-decoration: line-through;
                color: #93999f;
                font-weight: 700;
                line-height: 24px;
            }

             .foods-wrapper .food-item .content .cart-wrapper {
                position: absolute;
                right: 0;
                bottom: 12px;
            }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }

    .material-icons {
    font-size:36px;
    }
    .badge-class {
    font-size:18px;
    }
    .stateChoose {
        height: 32px;
        background: #fffbf2;
        border: 1px solid #ef9350;
        border-radius: 10px;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        color: #DA5B3A;
        padding: 0px 20px 0px 20px;
        line-height: 32px;
        margin-bottom: 5px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 10px;
        width:auto; 
        text-align: left;
        display: inline-block;
      }
       
      .stateNotChoose {
        height: 32px;
        background: #ffffff;
        border: 1px solid #E4E7ED;
        border-radius: 10px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #363636;
        line-height: 32px;
        padding: 0px 20px 0px 20px;
        margin-bottom: 5px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 10px;
        text-align: left;
        display: inline-block;
      }
</style>



// WEBPACK FOOTER //
// src/components/CartControl.vue